import React, { Component } from 'react';
import DOMPurify from 'dompurify';

import { Layout } from '../../components'
import Trans from '../../locale/Translate.js'
import TopNav from '../../modules/TopNav'

export default class PrivacyPolicy extends Component {
    render() {

        let language = localStorage.getItem('language');

        const user = JSON.parse(localStorage.getItem('agentData'));
        let content = user ? user.data.privacy_policy : null;

        const sanitizedContent = content ? DOMPurify.sanitize(content) : '';

        return (
            <Layout>
                <div className="jumbotron jumbotron-help" style={{ marginTop: '-30px' }}>
                    <div className="container text-center">
                        <h1>{Trans.data.privacy_policy}</h1>
                    </div>
                </div>

                <TopNav
                    url={this.props.location.pathname}
                />

                <div className="container">
                    <div className="row">
                        <div className="col-md-10 col-sm-10 col-md-offset-1">
                            <div className="row">
                                <div className="col-sm-12">
                                    <div className="blog-content">
                                        <div dangerouslySetInnerHTML={{ __html: sanitizedContent }} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Layout>
        )
    }
}